import { Navigate, useLocation } from "react-router-dom"
import { useApp } from "./context/AppContext"


const RedirectRoute = ({children}) => {
    const {isAuth} = useApp()
    const location = useLocation()

    if (isAuth) {
        return (
            <Navigate to='/auth/dashboard' state={{from: location}}/>
        )
    }
    return children
}

export default RedirectRoute